import React from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components/macro'

const LoadingBarAnim = keyframes`
  from {left: -100px; width: 10%;}
  50% {width: 30%;}
  70% {width: 70%;}
  80% {left: 50%;}
  95% {left: 120%;}
  to {left: 100%;}
`

export const LoaderContainer = styled.div`
  height: 5px;
  width: 100%;
  position: absolute;
  overflow: hidden;
  z-index: 1;
`

const LoaderBar = styled.div`
  display: block;
  position: absolute;
  left: -200px;
  width: 200px;
  height: 5px;
  background-color: #1792E5;
  animation: ${LoadingBarAnim} 2s linear infinite;
`

export const ProgressLoader = ({ loading }) => (
  <LoaderContainer>
    {loading
      ? <LoaderBar />
      : null
    }
  </LoaderContainer>
)

ProgressLoader.propTypes = {
  loading: PropTypes.bool.isRequired
}

ProgressLoader.defaultProps = {
  loading: false
}